var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('th',[_vm._v("Cxrtest")]),_c('th',[_vm._v("Cxrdate")]),_c('th',[_vm._v("Cxrres")])])
}
var staticRenderFns = []

export { render, staticRenderFns }